import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonFab, IonFabButton, IonIcon, 
    IonRow, IonCol, IonLabel, IonNote, IonImg, useIonModal, useIonToast,
    IonButton, IonButtons} from '@ionic/react';
import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import ExploreContainer from '../components/ExploreContainer';
import { add, logoApple, logoAndroid, chatboxEllipsesOutline, images, information, locationOutline, mailOutline, phonePortraitOutline, 
    pricetagOutline, chevronBackOutline, copyOutline, copySharp, 
    search,
    map,
    logoWhatsapp,
    callOutline,
    heartOutline,
    heart} from 'ionicons/icons';
import './Home.css';
import { RouteChildrenProps, useParams } from 'react-router';

import { Clipboard } from "@capacitor/clipboard";

import axiosCall from '../data/axios';
import InstallButton from '../components/InstallPWAButton';

import { Swiper, SwiperSlide } from 'swiper/react';

// import Swiper core and required modules
import { Navigation, Autoplay, Keyboard, Pagination, Scrollbar, Zoom  } from "swiper/modules";

import 'swiper/css';
import '@ionic/react/css/ionic-swiper.css';
import "swiper/css/navigation";
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/zoom';

import { SwiperZoomModal } from '../components/SwiperZoomModal';

import { markerDetails } from '../data/index';

import { addToFavourites, FavouritesStore } from "../data/FavouritesStore";

import { format } from 'date-fns';
import { Capacitor } from '@capacitor/core';
const formatTimestamp = (timestamp: any) => {
    return format(new Date(timestamp), 'PPpp'); // PPpp gives a readable format like June 6, 2024 at 11:37 AM
};

const MarkerDetails: React.FC<RouteChildrenProps> = (props) => {

    const webUrl = `${process.env.REACT_APP_WEB_URL}`;

    const { id } : any  = useParams();

    const [thisMarker, setThisMarker] = React.useState<any>({});

    let saleType = thisMarker?.sale_type == 'For Sale' ? 'sale' :
        thisMarker?.sale_type == 'For Rent' ? 'rent' : 'all';

    useEffect(() => {
        if (`${process.env.REACT_APP_ENVIRONMENT}` === 'development') {
            setThisMarker(markerDetails?.listing);
        } else {
            axiosCall("/api/listing/detail/"+id, 'get')
            .then((res) => {
                setThisMarker(res.data?.listing);
                saleType = res.data?.listing?.sale_type == 'For Sale' ? 'sale' : res.data?.listing?.sale_type == 'For Rent' ? 'rent' : 'all';
            });
        }
    }, [id]);

    const favourites = FavouritesStore.useState(s => s.product_ids);
	const [isFavourite, setIsFavourite] = useState(false);
	useEffect(() => {
        const tempIsFavourite = favourites.find(f => f === `${ thisMarker.sale_type }/${ thisMarker.id }`);
        setIsFavourite(tempIsFavourite ? true : false);
    }, [thisMarker, favourites]);

    let photos = thisMarker?.photos || [];

    let env = `${process.env.REACT_APP_ENVIRONMENT}`;
    const baseUrl = `${process.env.REACT_APP_BASE_URL}`;
	var images = photos.map((image: { photo: any; caption: any; }, i: any) => {
		return { src: env == 'staging' ? baseUrl + image.photo : image.photo, text: image.caption }
	});

    const zoomModalDismiss = () => {
        dismissZoomModal();
    }
        
    const [clickedImageKey, setClickedImageKey ] = useState(0);

    const [presentZoomModal, dismissZoomModal] = useIonModal(SwiperZoomModal, { zoomModalDismiss, images, clickedImageKey });

    function slideClick(imgKey: number){
    
        setClickedImageKey(imgKey);

        presentZoomModal({
            initialBreakpoint: 1,
            breakpoints: [0,1],
            backdropBreakpoint: 0,
            animated: true,
            cssClass: 'modal-fullscreen'
        });

    }

    const [presentToast] = useIonToast();

    const copyLink = () => {
        let url = window.location.href;
        if (Capacitor.isNativePlatform()) {
            url = webUrl + '/markerdetails/' + id;
        }
        navigator.clipboard.writeText(url);
    }

    const copyToClipboard = async (text: string): Promise<void> => {
        try {
            await Clipboard.write({
                string: text
            });
            presentToast({
                message: 'Copied to clipboard.',
                duration: 3000,
                color: 'success'
            });
        } catch (err) {
            console.error('Failed to copy text:', err);
            presentToast({
                message: 'Failed to copy text to clipboard.',
                duration: 3000,
                color: 'danger'
            });
        }
    };

    let msgTextBody = `Hello,%0a I am interested in the property "${thisMarker?.title}" listed on %0a ${webUrl}/markerdetails/${id} %0a`;

    const productCartRef = useRef<any | null>(null);
    const productFavouriteRef = useRef<any | null>(null);

    const addProductToFavourites = (e: React.MouseEvent, marker: any) => {

        e.preventDefault();
        e.stopPropagation();
        addToFavourites(marker);

        if(!productFavouriteRef.current) return;
        productFavouriteRef.current.style.display = "";
        productFavouriteRef.current.classList.add("animate__fadeOutTopRight");

        setTimeout(() => {
            if (productCartRef.current && productFavouriteRef.current) {
                productFavouriteRef.current.classList.remove("animate__fadeOutTopRight");
                productFavouriteRef.current.style.display = "none";
            }
        }, 500);
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle> </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <IonHeader collapse="condense">
                    {Capacitor.isNativePlatform() && (
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonButton color="dark" routerLink="/" routerDirection="back">
                                    <IonIcon color="dark" icon={ chevronBackOutline } />&nbsp;Back
                                </IonButton>
                            </IonButtons>
                        </IonToolbar>
                    )}
                </IonHeader>
                {/*}
                <div style={{ textAlign: 'center', position: 'absolute', left: 0, right: 0, top: '50%', transform: 'translateY(-50%)' }}>
                    <strong>Still under construction</strong>
                    <p></p>
                </div>
                */}
                
                <IonRow className="ion-margin-bottom">
                    <IonCol size="10">
                        <IonRow>
                            <IonCol size="12">
                                <IonLabel>
                                    <h1>{thisMarker?.title}</h1>
                                    <IonNote>{thisMarker?.property_type} - {thisMarker.sale_type}</IonNote>
                                </IonLabel>
                            </IonCol>
                            <IonCol size="12">
                                <IonLabel>
                                    <IonNote>Posted on { thisMarker?.date_created ? formatTimestamp(thisMarker?.date_created) : '' } 
                                    {thisMarker?.show_names_emails && <span> by {thisMarker?.realtor_names}</span>}
                                    </IonNote>
                                </IonLabel>
                            </IonCol>
                        </IonRow>
                    </IonCol>
                    <IonCol size="2" className="ion-text-right">
                        <IonIcon color={ isFavourite ? "danger" : "medium" } 
                            icon={ isFavourite ? heart : heartOutline } onClick={ e => addProductToFavourites(e, thisMarker) } />
                        <IonIcon ref={ productFavouriteRef } style={{ position: "absolute", display: "none" }} 
                            className={ `animate__animated` } color="danger" icon={ heart } />
                    </IonCol>
				</IonRow>
				<IonRow>
					<IonCol>
						<Swiper 
							modules={[Navigation, Autoplay, Keyboard, Pagination, Scrollbar, Zoom]}
							autoplay={true}
							navigation={true}
							slidesPerView={2.5} initialSlide= {2} speed={400} spaceBetween= {10} centeredSlides={true} 
							zoom={true}
							loop={true}>
							{images.map((image: { src: string | string[] | undefined; }, i: number) => {
                                if(image.src && image.src !== 'undefined' && image.src !== 'null' && image.src !== 'NULL') {
                                    return <SwiperSlide key={i} onClick={() => slideClick(i)}>
                                        <div className="swiper-zoom-container">
                                        
										<IonImg src={typeof image.src === 'string' ? image.src : ''} />
                                        
                                        {/*<IonLabel>{image.text}</IonLabel>*/}
                                        
                                        </div>
                                    </SwiperSlide>
                                }
                            })}
						</Swiper>
					</IonCol>
				</IonRow>

				<IonRow className="ion-justify-content-start ion-align-items-center ion-margin-top">
					<IonCol size="1">
						<IonIcon icon={information} color="drukre" style={{fontSize: "1.5rem"}} />
					</IonCol>
					<IonCol size="11">
                        <div style={{ whiteSpace: "pre-wrap", userSelect: "text", WebkitUserSelect: "text" }}>
                            {thisMarker?.description}
                        </div>
                    </IonCol>
				</IonRow>

				<IonRow className="ion-justify-content-start ion-align-items-center">
					<IonCol size="1">
						<IonIcon icon={locationOutline} color="drukre" style={{fontSize: "1.5rem"}} />
					</IonCol>
					<IonCol size="11">{thisMarker?.address}</IonCol>
				</IonRow>

				<IonRow className="ion-justify-content-start ion-align-items-center">
					<IonCol size="1">
						<IonIcon icon={pricetagOutline} color="drukre" style={{fontSize: "1.5rem"}} />
					</IonCol>
					<IonCol size="11">Nu. {thisMarker?.price?.toLocaleString('en-IN')}</IonCol>
				</IonRow>

				{thisMarker?.show_names_emails && (
					<>
						{thisMarker?.additional_contact_info && (
							<IonRow className="ion-justify-content-start ion-align-items-center">
								<IonCol size="1">
									<IonIcon icon={phonePortraitOutline} color="drukre" style={{ fontSize: "1.5rem" }} />
								</IonCol>
								<IonCol size="5">
                                    {thisMarker?.additional_contact_info}
                                </IonCol>
                                <IonCol size="6" className="ion-text-right">
                                    <IonButton href={`tel:${thisMarker?.additional_contact_info}`} title="Call"><IonIcon icon={callOutline} /></IonButton>
                                    {thisMarker?.additional_contact_info.includes('+') ? (
                                            <IonButton href={`https://wa.me/${thisMarker?.additional_contact_info}?text=${msgTextBody}`} target="_blank" title="WhatsApp"><IonIcon icon={logoWhatsapp} /></IonButton>
                                        ) : thisMarker?.additional_contact_info.length == 8 ? (
                                            <IonButton href={`https://wa.me/+975${thisMarker?.additional_contact_info}?text=${msgTextBody}`} target="_blank" title="WhatsApp"><IonIcon icon={logoWhatsapp} /></IonButton>
                                        ) : <IonButton href={`https://wa.me/${thisMarker?.additional_contact_info}?text=${msgTextBody}`} target="_blank" title="WhatsApp"><IonIcon icon={logoWhatsapp} /></IonButton>
                                    }
                                    <IonButton title='Copy Phone Number' mode="md" onClick={() => copyToClipboard(thisMarker?.additional_contact_info)}> <IonIcon icon={copySharp} /></IonButton>
                                </IonCol>
							</IonRow>
						)}
						{thisMarker?.realtor_emails && !thisMarker?.realtor_emails.includes('tttwangchuk@gmail.com') && (
							<IonRow className="ion-justify-content-start ion-align-items-center">
								<IonCol size="1">
									<IonIcon icon={mailOutline} color="drukre" style={{ fontSize: "1.5rem" }} />
								</IonCol>
								<IonCol size="11">{thisMarker?.realtor_emails}</IonCol>
							</IonRow>
						)}
					</>
				)}
                <IonRow className="ion-float-end">
                    <IonCol>
                        <IonButton color="drukre" onClick={() => props.history.push('/')}>
                            <IonIcon icon={search} />Go to Search
                        </IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton color="tertiary" onClick={() => props.history.push('/map/' + saleType + '?find=' + id)}>
                            <IonIcon icon={map} />View it on Map
                        </IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton onClick={() => copyLink()} color="warning">
                            <IonIcon icon={copyOutline} /> &nbsp;&nbsp;Copy Link
                        </IonButton>
                    </IonCol>
                </IonRow>

                <IonFab vertical="bottom" horizontal="start" slot="fixed">
                    <IonFabButton onClick={() => props.history.push('/notice')}>
                        <InstallButton />
                    </IonFabButton>
                </IonFab>
            </IonContent>
        </IonPage>
    );
};

export default MarkerDetails;
